import { Navigate, useLocation } from "react-router-dom";
import { getRedirectSearch } from "src/hooks/useRedirectUrl";

const RedirectAuth = () => {
	const location = useLocation();
	return (
		<Navigate
			to={{
				pathname: "/login",
				search: `?${getRedirectSearch(location.pathname)}`,
			}}
		/>
	);
};

export default RedirectAuth;
